import { BaseService } from "@/script/core/service/BaseService"

export class WarnService extends BaseService {
}
